'use es6';

import setIn from 'transmute/setIn';
import { FILE_IDS } from '../constants/fileAttachmentKeyPaths';
export const setFileIds = setIn(FILE_IDS);